module.exports = "<div id=\"whatsappSupport\" class=\"whatsapp-container\" (click)=\"sendWhatsAppMessage()\" *ngIf=\"whatsappNumber\">\n  <div class=\"whatsapp-icon\">\n  </div>\n\n  <div class=\"support-text\">\n    ارسال پیام\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/whatsapp-support/whatsapp-support.component.html
// module id = 1097
// module chunks = 3